import type { TOC } from '@ember/component/template-only';
import SettingsRecommendationsDynamicRateRanges from 'lumen/components/settings/recommendations/dynamic-rate-ranges';
import type HotelSettingsRecommendationsDynamicRateRangesRoute from 'lumen/routes/hotel/settings/recommendations/dynamic-rate-ranges';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsRecommendationsDynamicRateRangesSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsRecommendationsDynamicRateRangesRoute>;
  };
}

<template>
  <SettingsRecommendationsDynamicRateRanges @model={{@model}} />
</template> satisfies TOC<HotelSettingsRecommendationsDynamicRateRangesSignature>;
